import { UnauthorizedError } from '@/errors'

import {
  ShopSettings,
  ShopSettingsResource,
  ShopSettingsResourcePayload
} from '@/models'

import axios, { withToken } from '../axios'

import {
  generateCreate,
  generateDelete,
  generateUpdate
} from '../crudGenerator'

/**
 * Converts ShopSettingsResource to ShopSettings.
 *
 * @param resource Reponse data to be converted.
 */
export function parseShopSettingsResource (resource: ShopSettingsResource): ShopSettings {
  return {
    id: resource.id,
    providerId: resource.accountId,
    businessUnitId: resource.shopId,
    menuType: resource.menuType
  }
}

const url = '/menu'
const entity = 'settings'

export default {
  /**
   * Creates a new ShopSettings.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param payload Data required to create it.
   */
  createShopSettings: generateCreate<ShopSettings, ShopSettingsResource, ShopSettingsResourcePayload>(url, entity, parseShopSettingsResource),

  /**
   * Deletes a ShopSettings.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id ShopSettings id to be deleted.
   */
  deleteShopSettings: generateDelete(url, entity),

  /**
   * Gets a ShopSettings.
   *
   * @param tokenV2 Valid token with an AccountId.
   */
  async fetchShopSettings (tokenV2: string, accountId: number, shopId: number) {
    try {
      const response = await axios.get<ShopSettingsResource>(
        `${url}/accounts/${accountId}/shops/${shopId}/${entity}`,
        withToken(tokenV2)
      )

      return parseShopSettingsResource(response.data)
    } catch (error) {
      const status = error?.response?.status

      if (status === 404) {
        return null
      } else if (status === 401) {
        return Promise.reject(new UnauthorizedError())
      } else {
        return Promise.reject(error)
      }
    }
  },

  /**
   * Updates an existing ShopSettings.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id ShopSettings id to be updated.
   * @param payload Data required to create it.
   */
  updateShopSettings: generateUpdate<ShopSettings, ShopSettingsResource, ShopSettingsResourcePayload>(url, entity, parseShopSettingsResource)
}
